import { useMemo } from "react";
import { bool, object, string } from "yup";
import { AdminAccessGroup } from "src/domain/AdminAccessGroup";


const useValidationAdminAccessGroupSchemaService = () => {
  const requiredMessage = "form.error.notEmpty";
  return useMemo(() => {

    // Schema représentant l'ensemble des champs du formulaire
    const validationSchema = object<AdminAccessGroup>().shape({
      id: string().nullable(),

      accessGroup: string().required(requiredMessage),
      typeAcces: string().required(requiredMessage),


    });
    return validationSchema;
  }, []);
};

export default useValidationAdminAccessGroupSchemaService;
